import { Box, Grid } from '@mui/material';
import '../../styles/squareDisplay.scss';


interface SquareDisplayProps {
    topLabel : string,
    centerLabel : Number,
    bottomLabel : string
}

export default function SquareDisplay({ topLabel, centerLabel, bottomLabel } : SquareDisplayProps) {

    return(
        <Box className = "displayElement">
            <Grid
                container
                spacing = {1}
                direction = "row">
                    
                <Grid item xs = {12} className = "textDisplayGrid">
                    <h2 className = "textSmall">{topLabel}</h2>
                    <h1 className = "textBig">{centerLabel}</h1>
                    <h2 className = "textSmall">{bottomLabel}</h2>
                </Grid>
            </Grid>
        </Box>
    );
}